import { Navigate, Outlet } from "react-router-dom";
import useAuth from "@/hooks/stores/useAuth";
import NotFound from "@/pages/NotProtectedOnly/404";

export const RoleBasedRoute = ({ allowedRoles }) => {
  const { userRole } = useAuth();
  const currentRole = userRole?.toLowerCase();

  if (!allowedRoles.includes(currentRole)) {
    // If user is a company, show 404 page
    if (currentRole === 'company') {
      return <NotFound />;
    }
    // For other unauthorized roles, redirect to companies page
    return <Navigate to="/companies" replace />;
  }

  return <Outlet />;
}; 